import * as API from "@/services/API";

export default {
  getCategories() {
    return API.apiClient.get("/homepage-categories");
  },
};
